/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:ebf572c9-81b7-4035-93e9-4b59deb85a00",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_nHZ9jnryI",
    "aws_user_pools_web_client_id": "qk474tnabasjjui818iinuk4a",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "amplifyrestapi",
            "endpoint": "https://d0212n5uk5.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
